import { Component, Injector, Input, OnInit } from '@angular/core';
import { BaseDialog } from '../../Dialog-types/base-dialog';
import { ButtonInfo, ValueAndDisplay } from '../../../UI-Components/helperClasses/value-and-display.class';
import { Validators } from '../../../Validators/validators';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LAYER_TYPES, STATUS_VISUALIZATION_METHOD } from '../../../../Store/layers.state/layers.model';
import { LayerTreeNode } from '../../../Models/UI/ui-tree-node.model';
import { LayersState } from '../../../../Store/layers.state/layers.state';
import { IValidator } from '../../../../Directives/directives.helper';
import * as _ from 'lodash';
import { takeUntil } from 'rxjs/operators';
import { LayerLogic } from './add-edit-layer-dialog.utils';
import { CustomOKButton, EditorMode } from '../dialog.helper';
import { LibIconsService } from '../../../../services/lib-icons.service';
import { IMAGE_SOURCE, ImagePickerComponent } from '../../../UI-Components/image-picker/image-picker.component';
import { statusIconSrc } from '../../../../Store/layers.state/layers.const.utils';
import { TableTemplateDialogComponent } from '../table-template-dialog/table-template-dialog.component';
import { DialogType, DialogService } from 'src/app/services/dialogs.service';
import { DialogRef } from '../../Dialog-types/dialog-ref';
import { DialogModel } from 'src/app/common/Models/Dialog/dialog.model';
import { InputsBindingsModel } from 'src/app/common/Models/Dialog/inputs-binding.model';
import { PalletColors } from 'src/app/common/Models/UI/colors.constant';
import { PiechartTemplateDialogComponent } from '../piechart-template-dialog/piechart-template-dialog.component';
import { cloneDeep } from 'lodash';
import { StatusShape } from 'src/app/common/UI-Components/layer-status-design-picker/layer-status-design-picker.component';
import { MatIcon } from '@angular/material/icon';
import { SelectionBoxComponent } from '../../../UI-Components/selection-box/selection-box.component';
import { InputBoxComponent } from '../../../UI-Components/input-box/input-box.component';
import { MultilineBoxComponent } from '../../../UI-Components/multiline-box/multiline-box.component';
import { SelectionBoxLayersComponent } from '../../../UI-Components/selection-box-layers/selection-box-layers.component';
import { NgStyle } from '@angular/common';
import { LayerStatusPreviewComponent } from '../../../UI-Components/layer-status-preview/layer-status-preview.component';
import { LayerStatusDesignPickerComponent } from '../../../UI-Components/layer-status-design-picker/layer-status-design-picker.component';
import { TooltipDirective } from '../../../../Directives/tooltip.directive';
import { SelectVisualizationComponent } from '../../../UI-Components/select-visualization/select-visualization.component';
import { CheckboxComponent } from '../../../UI-Components/checkbox/checkbox.component';

export const colorSeverityNumber: number = 12;

interface ILayerStatusDesign {
  status: number;
  bgColor: string;
  shape: string;
}

@Component({
    selector: 'ins-add-edit-layer',
    templateUrl: './add-edit-layer-dialog.component.html',
    styleUrls: ['./add-edit-layer-dialog.component.scss', './../shared-dialogs-ui.scss',
        './../../../UI-Components/shared-UI-components.scss'],
    imports: [MatIcon, SelectionBoxComponent, InputBoxComponent, MultilineBoxComponent, SelectionBoxLayersComponent, LayerStatusPreviewComponent, NgStyle, LayerStatusDesignPickerComponent, TooltipDirective, SelectVisualizationComponent, ImagePickerComponent, CheckboxComponent]
})

export class AddEditLayerDialogComponent extends BaseDialog implements OnInit {
  static firstLoading: boolean = true;
  layersTree$: Observable<LayerTreeNode[]>;
  public layerTypesButtonInfo: ButtonInfo[] = [];
  public layerLogicButtonInfo: ButtonInfo[] = [];
  public buttonsInfo: ButtonInfo[] = [];
  public enableReplaceImage: boolean = true;
  public isValidSeverity: boolean = true;
  public showPlacemarkDesignPicker: boolean = false;
  public placemarkDesignPickerPosition: any = {};
  public selectedLayerSatusDesign: ILayerStatusDesign;

  @Input() layerType: LAYER_TYPES = LAYER_TYPES.Site;
  @Input() name: string;
  @Input() layerId: string;
  @Input() description: string;
  @Input() parentLayer: string;
  @Input() image: any; // Can be File or string
  @Input() isVisibleByDefault: boolean = true;
  @Input() selectedStatusList: boolean[] = [];
  @Input() statusColors: string[] = [];
  @Input() statusShapes: string[] = [];
  @Input() layerLogic: LayerLogic = LayerLogic.most_severe;
  @Input() dialogMode: EditorMode = EditorMode.NEW;
  @Input() visualizationMethod = STATUS_VISUALIZATION_METHOD.STATUS_TAG;
  @Input() visualizationConf: any = {};

  imageSource: IMAGE_SOURCE = IMAGE_SOURCE.libIcon;
  public disabledCheckboxesInStatus: boolean[] = [];
  public IndicesForSeverity: number[] = _.range(colorSeverityNumber);
  validatorForImage: IValidator[] = [];
  public layerTypesEnum: any = LAYER_TYPES;
  public layersLogicOptions: ValueAndDisplay[] = [{ value: LayerLogic.most_severe, displayValue: 'Most severe' },
  { value: LayerLogic.quantitative, displayValue: 'Quantitative' }];
  public imageList: string[] = ['factory', 'floorPlan', 'maintainance', 'staff', 'orders', 'people', 'quality',
    '3d', 'social', 'line', 'webcam', 'station', 'zone', 'manuals', 'performance', 'utilization', 'information', 'reports', 'building'];

  ignoredLayersTypes: LAYER_TYPES[] = [LAYER_TYPES.General];
  constructor(public injector: Injector, public validators: Validators, public libIconSrv: LibIconsService, public dialogSrv: DialogService, private store: Store) {
    super(injector);
    this.layersTree$ = this.store.select(LayersState.getLayersTree);
    this.imageList.forEach((imageName: string) => {
      this.libIconSrv.getIdByName(imageName);
    });
  }

  ngOnInit(): void {
    this.layerTypesButtonInfo.push(
      new ButtonInfo(LAYER_TYPES.Site, 'Information'),
      new ButtonInfo(LAYER_TYPES.Status, 'Status'),
      new ButtonInfo(LAYER_TYPES.Group, 'Group')
    );

    if ( this.dialogMode === EditorMode.EDIT ) {
      this.layerTypesButtonInfo.push(new ButtonInfo(LAYER_TYPES.Scan, 'Scan'))
    }

    this.buttonsInfo.push(
      new ButtonInfo('cancel', 'Cancel'),
      new ButtonInfo('ok', CustomOKButton.get(this.dialogMode))
    );
    this.layerLogicButtonInfo.push(
      new ButtonInfo(LayerLogic.most_severe, 'Most severe'),
      new ButtonInfo(LayerLogic.quantitative, 'Quantitative')
    );
    if (this.parentLayer === undefined) {
      this.layersTree$.pipe(takeUntil(this.unsubscribe)).subscribe((layers) => {
        this.parentLayer = new LayerTreeNode('0', 'Root', undefined, layers).id;
      });
    }

    if (this.selectedStatusList.length === 0) {
      for (let i: number = 0; i < colorSeverityNumber; i++) {
        this.selectedStatusList.push(false);
      }
    }
    if (this.statusColors.length === 0) {
      for (let i: number = 0; i < colorSeverityNumber; i++) {
        this.statusColors.push('');
      }
    }
    if (this.statusShapes.length === 0) {
      for (let i: number = 0; i < colorSeverityNumber; i++) {
        this.statusShapes.push('');
      }
    }
    if (this.disabledCheckboxesInStatus.length === 0) {
      for (let i: number = 0; i < colorSeverityNumber; i++) {
        this.disabledCheckboxesInStatus.push(this.selectedStatusList[i]);
      }
    }
  }

  public defineDialogModel(): void {
    this.dialogModel.initModel(
      ['layerType', this.layerType],
      ['name', this.name],
      ['layerId', this.layerId],
      ['description', this.description],
      ['isVisibleByDefault', this.isVisibleByDefault],
      ['parentLayer', this.parentLayer],
      ['image', this.image],
      ['selectedStatusList', this.selectedStatusList],
      ['statusColors', this.statusColors],
      ['statusShapes', this.statusShapes],
      ['dialogMode', this.dialogMode],
      ['layerLogic', this.layerLogic],
      ['visualizationMethod', this.visualizationMethod],
      ['visualizationConf', this.visualizationConf]
    );
  }

  onChanges(): void { }

  changeLayerType($event: any): void {
    switch ($event) {
      case LAYER_TYPES.Group: {
        if (this.dialogMode === EditorMode.NEW) {
          this.isVisibleByDefault = false;
        }
        this.enableReplaceImage = false;
        if (this.validatorForImage.length !== 0) {
          this.validatorForImage = [];
        }
        if (this.image === '') {
          this.updateDialogValidity(true);
        }
        if (!this.isValidSeverity) {
          this.isValidSeverity = true;
          this.updateDialogValidity(true);
        }
        break;
      }
      case LAYER_TYPES.Site: {
        if (this.dialogMode === EditorMode.NEW) {
          this.isVisibleByDefault = true;
        }
        this.enableReplaceImage = true;
        if (this.validatorForImage.length === 0) {
          this.validatorForImage = [this.validators.Required];
        }
        this.imageSource = IMAGE_SOURCE.libIcon;
        if (this.dialogMode === EditorMode.NEW) {
          this.image = '';
        }
        // edit mode
        if (this.dialogMode !== EditorMode.NEW && !this.libIconSrv.isIdExists(this.image)) {
          this.imageSource = IMAGE_SOURCE.externalUrl;
        }
        if (!this.isValidSeverity && !AddEditLayerDialogComponent.firstLoading) {
          this.isValidSeverity = true;
          this.updateDialogValidity(true);
        }
        AddEditLayerDialogComponent.firstLoading = false;
        break;
      }
      case LAYER_TYPES.Status: {
        if (this.dialogMode === EditorMode.NEW) {
          this.isVisibleByDefault = true;
        }
        this.enableReplaceImage = false;
        this.image = statusIconSrc;
        this.imageSource = IMAGE_SOURCE.localUrl;
        if (this.validatorForImage.length !== 0) {
          this.validatorForImage = [];
          this.updateDialogValidity(true);
        }
        this.severityChange();
        break;
      }
    }
  }
  
  openLayerStatusDesignPicker(index, colorButton: any): void {
    if (this.showPlacemarkDesignPicker) {
      return;
    }
    this.showPlacemarkDesignPicker = false;
    this.selectedLayerSatusDesign = null;
    if (index === - 1) {
      this.selectedLayerSatusDesign = {
        status: 0,
        bgColor: 'FFFFFF',
        shape: StatusShape.Circle
      };
    } else {
      this.selectedLayerSatusDesign = {
        status: index + 1,
        bgColor: this.statusColors[index],
        shape: this.statusShapes[index]
      };
    }
    this.placemarkDesignPickerPosition['top'] = colorButton.getBoundingClientRect().top + 16 + 'px';
    this.placemarkDesignPickerPosition['left'] = colorButton.getBoundingClientRect().left + 16 + 'px';
    this.showPlacemarkDesignPicker = true;
  }

  layerStatusDesignRemove(placemarksDesign: ILayerStatusDesign): void {
    const index: number = placemarksDesign.status - 1;
    this.selectedLayerSatusDesign = null;
    this.showPlacemarkDesignPicker = false;
    this.statusColors[index] = '';
    this.statusShapes[index] = '';
    this.selectedStatusList[index] = false;
    this.severityChange();
  }

  layerStatusDesignChange(placemarksDesign: any): void {
    if (placemarksDesign) {
      const index: number = placemarksDesign.status - 1;
      this.statusColors[index] = placemarksDesign.bgColor;
      this.statusShapes[index] = placemarksDesign.shape;
      this.selectedStatusList[index] = this.statusColors[index] !== '';
      this.severityChange();
    }

    this.selectedLayerSatusDesign = null;
    this.showPlacemarkDesignPicker = false;
  }

  showAddStatusButton(): boolean {
    return this.selectedStatusList.some(status => !status);
  }

  severityChange(): void {
    if (this.layerType === LAYER_TYPES.Status) {
      let checkedAndColored = false;
      for (let i = 0; i < colorSeverityNumber; i++) {
        if (this.selectedStatusList[i] && this.statusColors[i] !== '') {
          checkedAndColored = true;
        }
        if ((!this.selectedStatusList[i] && this.statusColors[i] !== '') || (this.selectedStatusList[i] && this.statusColors[i] === '')) {
          checkedAndColored = false;
          break;
        }
      }
      if (checkedAndColored !== this.isValidSeverity) {
        this.isValidSeverity = checkedAndColored;
        this.updateDialogValidity(checkedAndColored);
      }
    }
  }

  onChangeImageSource($event: IMAGE_SOURCE): void {
    this.imageSource = $event;
  }

  visualizationMethodChange(method: string) {
    switch(method) {
      case STATUS_VISUALIZATION_METHOD.TABLE:
        if (!this.visualizationConf.table) {
          this.initializeTableVisualizationConf();
        }
        break;
      case STATUS_VISUALIZATION_METHOD.PIECHART:
        if (!this.visualizationConf.piechart) {
            this.initializePiechartVisualizationConf();
        }
        break;
    }
  }

  editTemplateForStatusPm($event: string) {
    if (!this.visualizationConf[this.visualizationMethod]) {
      return;
    }
    const inputsBinding: InputsBindingsModel = new Map();
    inputsBinding.set('visualizationConf', cloneDeep(this.visualizationConf[this.visualizationMethod]));

    if (this.visualizationMethod == STATUS_VISUALIZATION_METHOD.TABLE) {
      const dialog: DialogRef = this.dialogSrv.createDialog(TableTemplateDialogComponent, DialogType.Modal, inputsBinding, null, 390);
      dialog.onClose$().subscribe((model: DialogModel) => {
        if (model.userAction == 'apply') {
          this.visualizationConf.table = model.getData('visualizationConf');
        }
      });
    } else if (this.visualizationMethod == STATUS_VISUALIZATION_METHOD.PIECHART) {
      const dialog: DialogRef = this.dialogSrv.createDialog(PiechartTemplateDialogComponent, DialogType.Modal, inputsBinding, null, 390);
      dialog.onClose$().subscribe((model: DialogModel) => {
        if (model.userAction == 'apply') {
          this.visualizationConf.piechart = model.getData('visualizationConf');
        }
      });
    }
  }

  initializeTableVisualizationConf() {
    this.visualizationConf.table = {
      showTableHeader: false,
      tableHeaderName: '',
      showColumnTitle: true,
      rowCount: 5,
      colDef: [
        { columnName: 'Variable Name', field: 'name', visible: true, columnTextColor: 'white', columnBgColor: PalletColors[3].color },
        { columnName: 'Variable Value', field: 'value', visible: true, columnTextColor: 'black', columnBgColor: PalletColors[4].color },
      ]
    }
  }

  initializePiechartVisualizationConf() {
    this.visualizationConf.piechart = {
      showChartName: false,
      chartName: '',
      showValue: true,
      showLegend: true,
      pieDiameter: 100,
      colorConf: [
        { color: PalletColors[1].isDark ? 'white' : 'black', bgColor: PalletColors[1].color },
        { color: PalletColors[2].isDark ? 'white' : 'black', bgColor: PalletColors[2].color },
        { color: PalletColors[3].isDark ? 'white' : 'black', bgColor: PalletColors[3].color },
        { color: PalletColors[4].isDark ? 'white' : 'black', bgColor: PalletColors[4].color },
        { color: PalletColors[9].isDark ? 'white' : 'black', bgColor: PalletColors[9].color },
        { color: PalletColors[0].isDark ? 'white' : 'black', bgColor: PalletColors[0].color }
      ]
    }
  }
}
